module.exports = {
  login: { //登录页面
    title: '账号登录',
    rememberPsd: '记住密码',
    forgetPsd: '忘记密码',
    signIn: '登录',
    signUp: '注册',
    enteraccount: '邮箱/手机号',
    accountnot: '账号不存在！',
    accountpassword: '密码',
    entercode: '请输入验证码',
    ApplyQrCode: '申请吊牌',
    ThirdPartyLogin: '第三方登录',
    accountLength: '账户长度已达到最大长度32位',
    passwordLength: '密码长度已达到最大长度16位',
    noAccOrPsd:'账号密码不能为空',
    enterid:'输入产品ID',
    scanphone:'拍照扫码',
    platform:'协寻平台',
    areaCode:'国家与地区',
    agree:'登录即同意',
    privacyStatement:'隐私政策',
    setLoginPsw:'请设置登录密码并确认密码',
    pswSimple:'请输入六位及以上的数字和字母组合密码！'
  },
  btn: {
    text: 'button'
  },
  btmNavBar: { //底部导航
    device: '设备',
    finder: '协寻圈',
    my: '我的'
  },
  finder: { //协寻列表
    find: '协寻圈',
    filtrateTime: '最新', //时间筛选
    filtrateDis: '距离', //距离筛选
    noMoreFind: '没有更多协寻信息',
    pullRefresh: '下拉刷新',
    noComment:'暂无评论',
    noMoreComment:'已展示全部评论',
    comments:'最新评论',
    enterComment:'请输入评论内容！',
    notAccount:'请登录查看评论信息'
  },
  device: { //设备列表
    noLogin: '请登录后查看设备',
    myDevice: '我的设备',
    deviceNull: '您还没有添加任何多尼斯智能产品',
    goLogin: '去登录',
    deviceCode: '设备编号',
    bindPet: '绑定的宠物',
    noBindPet: '此设备未绑定宠物',
    hint: '如需删除设备，请先解绑宠物再删除',
    unbind: '解绑',
    delDevice: '删除',
    addNewDevice: '添加新设备',
    nobindDevice: '您还未绑定任何多尼斯设备',
    isDelete: '是否要删除设备',
    deleteDevice: '删除设备',
    nodevice:'暂无设备',
    content:'请联系客服购买',
    contentnum:'400-891-8580',
    scanning:'请先扫描并绑定吊牌二维码'               
  },
  addDevice: {
    scanQRC: '扫描二维码',
    makePhotoSign: '点击上方相机按钮拍摄多尼斯设备二维码以绑定设备',
    ifConntRecog: '若无法识别可尝试',
    inputQRC: '输入二维码编号',
    recogQRC: '识别选中的二维码',
    reMake: '我想重拍',
    chackYourId:'检测到您的设备ID为：',
    bingDev:'绑定设备',
    cancel:'取消',
    recogging:'正在识别二维码，请稍后...',
    conntRecog:'未识别选区内的二维码，请正面对准二维码或微调选取内容',
    QRCcontent:'识别的二维码内容',
    sure:'确定',
    successBind:'绑定成功',
    alreadyBinged:'该设备已经被绑定过了',
    notexist:'设备不存在！'
  },
  bindById:{
    inputId:'输入ID绑定设备',
    pleaseInput:'请输入设备二维码编号',
    sureBind:'确认绑定',
    successBind:'绑定成功',
    alreadyBinged:'该设备已经被绑定过了',
    faileBind:'绑定失败，请输入正确的设备号码',
    cannotBind:'非吊牌设备不能被绑定'
  },
  my: {
    myAccount: "我的用户",
    myPet: "我的宠物",
    masterInfo: '主人信息',
    myFinder: '我的协寻',
    changePsd: '修改密码',
    onlineService: '在线客服',
    FAQ: '常见问题',
    exit: '退出登录',
    isExit:'是否退出登录',
    myname:'个人名称'
  },
  searchmessage:{
    title:'标题',
    describe:'协寻简介',
    petphone:'宠物照片'
  },
  mysearch: {
    status: '状态',
    finding: '寻找中',
    finded: '已找到',
    closed: '已关闭',
    time: '时间',
    publishFind: '发布协寻',
    clickToCheck: '点击查询扫码记录',
    losePlace: '走失地点',
    loseTime: '走失时间',
    stopfind: '当前没有在寻找中的宠物',
    nofindpet: '当前没有已找到的宠物',
    nostoppet: '当前没有已关闭的宠物',
    success:'发布成功',
    lost:'发布失败',
  },
  petstatus:{
  	petinfo:'避免宠物走失，请填写您的宠物信息',
  	petlookafter:'请牵好您的爱宠，避免宠物走失',
  	petmissing:'我迷路了，请带我回家！',
  	petfinding:'已发布协寻，请等待信息',
  },
    mapinfo: {
    sure: '确定'
  },
  activation:{
  	sure:'激活',
  	success:'激活成功',
  },
  introduction:{
  	sure:'简介'	,
  	introductiontitle:'协寻简介',
  	introduction01:'让所有爱心人士为您守护爱犬',
  	introduction02:'只需要3步骤操作：',
  	introduction03:'填写主人与宠物的信息，并激活使用',
  	introduction04:'一旦激活使用，任何用户扫描二维码便可看到主人与宠物的信息',
  	introduction05:'若宠物走失，主人可以发布协寻，一旦爱心人士扫描您宠物的吊牌二维码，您便可以知道当前宠物的位置，并与爱心人士建立联系，让宠物尽快回到您的身边',
  },
  menu:{
  	changeinfo:'修改信息',
  	mytag:'我的吊牌',
  	scanningrecord:'扫码记录'
  },
  changeinfos:{
  	sure:'确认',
  	changeinfostitle:'二维码扫描记录'
  },
  lossinfo:{
  	sure:'发布丢失',
  	close:'关闭'
  },
  changefindpetinfo: {
    changefind: '协寻修改',
    findPet: '协寻宠物',
    clickToChangePlace: '点击下方可更换地点',
    petPhotos: '宠物照片（最多3张）',
    publicRelation: '公开联系方式',
    findStatus: '协寻状态',
    commit: '提交',
    more: '可多选',
    select: '请选择',
    enterTitle: '请输入标题20字以下',
    describe: '请对爱宠和走丢情况进行详细描述……',
    change: '正在修改中，请稍后',
    failure: '请求失败'
  },
  masterInfo: {
    masterInfo: '主人信息',
    nickName: '昵称',
    sex: '性别',
    email: '邮箱',
    phone: '联系电话',
    add: '联系地址'
  },
  changepassword: {
    oldPsd: '请输入旧密码',
    newPsd: '请输入新密码',
    againPsd: '请再次输入新密码',
    trueChange: '确认修改',
    notPsd: '密码不能为空',
    falsePsd: '密码不正确',
    lessPsd: '密码不能少于6位',
    notSamePsd: '密码不一致'
  },
  petDetails: {
    find: '协寻',
    findInfo: '协寻详情',
    petintro: '宠物介绍',
    relationPer: '联系人',
    relationWay: '联系方式',
    relHelp: '相关求助',
    share: '分享到',
    cancelshare: '取消分享',
    wx: '这是微信浏览器',
    lost: '走失地址'
  },
  addpet: {
    cat:'猫猫',
    dog:'狗狗',
    addpet: "添加宠物",
    setPetPortrait: '设置宠物头像',
    petName: '宠物昵称',
    petType: '宠物品种',
    color: '宠物毛色',
    sex: '宠物性别',
    weight: '宠物体重',
    height: '宠物身高',
    birthday: '宠物生日',
    character: '宠物性格',
    trueAdd: '添加宠物',
    flag2: '只能中英文，数字，下划线，减号',
    notpetName: '宠物名称未填写',
    enterchinese: '只能中英文',
    notpetType: '宠物品种未填写',
    notpetColor: '宠物毛色未填写',
    notpetSex: '宠物性别未选择',
    not: '只支持最多三位整数或保留两位小数',
    enterweight: '请输入体重',
    enterheight: '请输入身高',
    notWeight: '宠物体重未填写',
    notHeight: '宠物身高未填写',
    selectData: '请选择日期',
    selectSex: '请选择性别',
    notBirthday: '出生日期未选择',
    entercharacter: '请输入性格',
    notcharacter: '宠物性格未填写',
    entername: '请输入宠物昵称',
    enterType: '请选择品种',
    enterColor: '请输入毛色',
    have: '不能为空',
    savechage: '保存修改',
    petNews: '宠物信息',
    deletePet: '删除宠物',
    report: '发布协寻',
    submiting: '正在提交,请稍等'
  },
  privacyStatement:{
    appPrivacy:'App隐私声明',
    addEnglish:'',
    addEnglish1:'',
    phead:'《多尼斯》注重您个人隐私的保护。有时候我们需要某些信息才能为您提供您请求的服务，本隐私权声明解释了这些情况下的数据收集和使用情况。本隐私权声明适用于《多尼斯》APP应用产品的所有相关服务。',
    one:'您个人信息的搜集',
    addEnglish2:'',
    onecontent:'当我们需要能识别您身份的信息（个人信息）或者可以与您联系的信息时，我们会征求您的同意。',
    two:'控制您的个人信息',
    twocontent:'《多尼斯》会在法律要求或符合《多尼斯》的相关服务条款、软件许可使用协议约定的情况下透露您的个人信息，或者有充分理由相信必须这样做才能：(a) 满足法律的明文规定，或者符合《多尼斯》本应用适用的法律程序；（b）符合《多尼斯》相关服务条款、软件许可使用协议的约定；(c) 保护《多尼斯》的权利或财产，以及 (d) 在紧急情况下保护《多尼斯》员工、《多尼斯》产品或服务的用户或大众的个人安全。',
    twocontent1:'《多尼斯》不会未经允许将这些信息与第三方共享，本声明已经列出的情况除外',
    three:'您个人信息的安全',
    threecontent:'严格保护您的个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。如果您对我们的隐私保护有任何置疑，请email至service@dognesstech.com',
    
    addEnglish3:'',
    addEnglish4:'',
    addEnglish5:'',
    addEnglish6:'',
    addEnglish7:'',
    addEnglish8:'',
    addEnglish9:'',
    addEnglish10:'',
    addEnglish11:'',
    addEnglish12:'',
    addEnglish13:'',
    addEnglish14:'',
    addEnglish15:'',
    addEnglish16:'',
    addEnglish17:'',
    addEnglish18:'',
    addEnglish19:'',
    addEnglish20:'',
    addEnglish21:'',
    addEnglish22:'',
    addEnglish23:'',
    addEnglish24:'',
    addEnglish25:'',
    addEnglish26:'',
    addEnglish27:'',
    addEnglish28:'',
    addEnglish29:'',
    addEnglish30:'',
    addEnglish31:'',
    addEnglish32:'',
    addEnglish33:'',
    addEnglish34:'',
    addEnglish35:'',
    addEnglish36:'',
    addEnglish37:'',
    addEnglish38:'',

    four:'关于免责',
    fourcontent:' 就下列相关事宜的发生，《多尼斯》不承担任何法律责任：',
    fourcontent1:'《多尼斯》根据法律规定或相关政府的要求提供您的个人信息;',
    fourcontent2:'非因《多尼斯》原因导致的个人信息的泄漏；',
    fourcontent3:'任何第三方根据《多尼斯》各服务条款及声明中所列明的情况使用您的个人信息由此所产生的纠纷；',
    fourcontent4:'任何由于黑客攻击、电脑病毒侵入或政府管制而造成的暂时性服务停止；',
    fourcontent5:'因不可抗力导致的任何后果；',
    fourcontent6:'《多尼斯》在各服务条款及声明中列明的免责情形 。',

    addEnglish39:'',
    addEnglish40:'',
    addEnglish41:'',
    addEnglish42:'',
    addEnglish43:'',
    addEnglish44:'',
    addEnglish45:'',
    addEnglish46:'',
    addEnglish47:'',
    addEnglish48:'',
    addEnglish49:'',
    addEnglish50:'',
    addEnglish51:'',
    addEnglish52:'',

    five:'隐私声明的修订：',
    fivecontent:'根据需要，将随时修改本隐私声明。我们建议用户定期上网查看最新的隐私政策于使用条款规定。未来任何条款如有更新，我们将不主动提醒用户，亦不会回溯应用在之前所发生的情形，同时不会改变我们对于之前所收集的资料之处理方式。',
    fivecontent1:'联系方式：service@dognesstech.com',

    addEnglish53:'',
    addEnglish54:''
  },
  userInformation: {
    changeImg: '点击头像可删除更换',
    enterusername: '输入昵称',
    username: '昵称',
    phonenumber: '手机号',
    email: '邮箱',
    savechage: '保存修改'
  },
  //sharon2018-11-12
  complete: {
    finishregister: '恭喜您完成注册',
    gologin: '立即登录'
  },
  emailproving: {
    register: '注册账号',
    lastStep: '还差一步即可完成注册',
    textone: '我们已经向您的邮箱发送了一封激活邮件，',
    texttwo: '请点击邮件中的链接完成注册！',
    resend: '如未收到邮件，请点击重新发送！',
    ActivateAccount: '进入邮箱激活账号'
  },
  forgetpassword: {
    resetpassword: '重置密码',
    resetpasswordphone: '手机重置密码',
    resetpasswordemail: '邮箱重置密码',
    setpassword:'设置密码',
    //手机在重置密码
    EnterPhone: '请输入手机号',
    FalsePhone: '手机号格式不正确',
    NoPhone: '手机号未注册',
    NotPhone: '手机号不能为空',
    NotCode: '验证码不能为空!',
    NoMatch: '验证码不正确!',
    next: '下一步',
    HadAccount: '已有账号请前往登录',
    sendcode: '发送验证码',
    sendcode2:'发送',
    sendContent2:'请输入文字发送',
    verify: '获取验证码',
    resend: '重新发送',
    notresend: '短信不能重复发送',
    //邮箱在重置密码
    EnterEmail: '请输入邮箱',
    FalseEmail: '邮箱格式不正确',
    NoEmail: '邮箱未注册',
    NotEmail: '邮箱不能为空!',
    submit: '提交',
    findemail: '邮箱找回?',
    finish: '完成',
    authcodeerror: '验证码错误',
    authcodeemail: '请前往邮箱进行验证',
    notemail: '邮箱未填写',
    findphone: '手机找回?'
  },
  loginswiper: {
    goregister: '立即注册'
  },
  mynews: {
    masternews: '主人信息',
    mastername: '主人昵称',
    mastersex: '性别',
    masteremail: '邮箱号',
    masterphone: '手机号码',
    masteradr: '地址'
  },
  mynewsedit: {
    EditMasterNews: '编辑主人信息',
    setImg: '设置头像',
    EnterMastername: '请输入主人昵称',
    ChoiceSex: '选择性别',
    EnterMasterphone: '请输入联系电话',
    EnterMasteradr: '请输入联系地址',
    finish: '完成',
    boy: '男',
    girl: '女',
    failure: '上传失败!'
  },
  register: {
    registerphone: '手机注册',
    registeremail: '邮箱注册',
    //手机注册
    registeredphone: '手机号已被注册',
    //邮箱注册
    registeredemail: '邮箱已被注册',
    enterPsd: '六位以上的数字和字母组合密码',
    againEnterPsd: '再次输入密码',
    notAgainPsd: '确认密码不能为空'
  },
  registerfalse: {
    failurelink: '链接已经失效'
  },
  resetemailproving: {
    lastone: '我们已经成功发送邮件到您的邮箱：',
    lasttwo: '请根据提示，重置您的密码并妥善保存！',
    resetPsdEmail: '进入邮箱重置密码'
  },
  resetsuccess: {
    changesuccess: '恭喜您修改成功'
  },
  //Sharon2018-11-13
  findPetInfo: {
    bound: '该设备已经被绑定了',
    enterplatform: '进入平台'
  },
  qrFindError: {
    deviceError: '不识别此设备，',
    toPlat:'请联系客服'
  },
  releaseSearch: {
    report: '请补充宠物走失信息便于寻回宠物',
    title: '请输入标题20字以下',
    nottitle: '标题未填写',
    mastermessage:'主人留言',
    decription: '爱宠丢失，主人十分担心，请寻到宠物的爱心人士及时联系主人，谢谢',
    notneed: '需求未填写',
    losttime: '走失时间',
    choicetime: '选择日期',
    nottime: '时间未选择',
    lostadr: '走失地点(点击下方可更换地点)',
    choicepet: '选择宠物',
    petImg: '宠物照片',
    opencontact: '公开联系方式',
    choice: '请选择',
    notcontact: '没有此联系方式，请更换或者去填写',
    preserve:'保存',
    cancel:'取消',
  },
  connectDevice: {
    accessnetwork: '多尼斯智能设备网络接入',
    configuration: '手机生成二维码后对准设备摄像头月15cm左右前后微调，可使智能设备摄像头更容易识别二维码'
  },
  createQrCode: {
    wifiname: '请输入正在连接的wifi名',
    wifipassword: '请输入正在连接的wifi密码',
    QrCode: '生成二维码'
  },
  deviceManage: {
    proName: '产品名称',
    proType: '产品类型',
    proNum: '产品编号',
    boundpet: '绑定宠物',
    noboundpet: '未绑定宠物',
    nopet: '您还没添加宠物',
    reportfindnews: '发布协寻信息',
    unbind: '设备解绑',
    failure: '失败'
  },
  binddevice: {
    boundDevice: '绑定设备:',
    clickAddDevice: '点击添加设备'
  },
  changepet: {
    name: '小小柴',
    surebind: '确定绑定'
  },
  choosePet: {
    mycute: '我的萌宠',
    choicecute: '选择萌宠'
  },
  //提示框
  prompt: {
    noactivationemail: '用户帐户尚未激活！邮件已经重新发送，请进入邮箱激活账号！',
    messageerror: '账号或密码错误',
    loginswiperError: '用户名或密码输入错误',
    notapply: '未提供',
    nocontact: '未提供',
    openemail: '公开邮箱',
    openphone: '公开手机',
    openall: '公开手机和邮箱',
    notChoicePet: '宠物未选择',
    notChoiceConcact: '公开联系方式未选择',
    notChoiceImg: '宠物生活照未选择',
    found: '您的宠物已经发布过协寻信息了',
    notdevice: '该宠物未绑定设备',
    scan: '请使用第三方扫一扫功能',
    scanQrCode: '请将二维码对准设备摄像头',
    bindpetsuccess: '绑定宠物成功!',
    removedevice: '确定要解绑设备吗?',
    cancelchange: '是否放弃修改?',
    delete: '此操作将永久删除该宠物, 是否继续?',
    promptcancel: '提示',
    remove: '解绑',
    sure: '确定',
    cancel: '取消',
    cancelbind: '解绑成功',
    deletesuccess: '删除成功',
    findingpet: '该宠物在协寻中!',
    notcancel: '已取消解绑',
    feeder: '智能喂食器',
    bluetooth: '蓝牙计步器',
    robot: '宠物机器人',
    QrCode: '协寻二维码',
    necklace: '智能项圈',
    mianbaoji: '迷你逗宠器',
    toushiqi: '智能投食器',
    sending: '正在发送邮件，请稍等！',
    boy: '公',
    girl: '母',
    notpetimg: '宠物头像未添加',
    againlogin: '账号登录过期，请重新登录',
    contentInteval: '保存失败，内容含有不能识别文字或表情',
    addfailure: '有信息未填写，添加失败!',
    nopetlifepic: '宠物生活照不能为空',
    cantdelete: '该宠物在协寻中或者设备未解绑，无法删除!',
    canceldelete: '取消删除',
    ycanceldelete: '已取消删除',
    choosePetone: '宠物正在协寻中不可以绑定',
    choosePettwo: '选择宠物失败',
    header: '用户登录超时，请重新登录',
    slider: '是否要解绑该宠物？',
    yslider: '解绑宠物',
    finding: '当前宠物正在协寻哟！',
    nodevice: '设备不存在，请联系客服',
    bindfailure: '绑定失败，设备已经被其他用户登录',
    contactkf: '系统故障请联系客服人员',
    noscan: '暂无扫码记录',
    noApply:'您的浏览器暂不支持该类型的分享!',
    showTimes:'该设备被扫描的次数是',
    QrnoCode: '请扫描设备二维码进入',
    tokenfailure:'授权登录失效，请重新扫码登录',
    noexpression:'不支持表情输入',
  },
  countries: {
    china: '中国',
    hongkong: '中国香港',
    macau: '中国澳门',
    taiwan: '中国台湾',
    America: '美国',
    Germany: '德国',
    Japan: '日本',
    Albania: '阿尔巴尼亚',
    Algeria: '阿尔及利亚',
    Afghanistan: '阿富汗',
    Argentina: '阿根廷',
    UnitedArabemirates: '阿拉伯联合酋长国',
    Aruba: '阿鲁巴',

    Oman:'阿曼',
    azerbaijan:'阿塞拜疆',
    Egypt:'埃及',
    Ethiopia:'埃塞俄比亚',
    Ireland:'爱尔兰',
    Estonia:'爱沙尼亚',
    Andorra:'安道尔',
    Angola:'安哥拉',
    anguilla:'安圭拉',
    AntiguaAndBarbuda:'安提瓜和巴布达',
    Austria:'奥地利',
    Australia:'澳大利亚',
    Barbados:'巴巴多斯',
    PapuaNewGuinea:'巴布亚新几内亚',
    Bahamas:'巴哈马',
    Pakistan:'巴基斯坦',
    Paraguay:'巴拉圭',
    Palestine:'巴勒斯坦',
    bahrain:'巴林',
    panama:'巴拿马',
    Brazil:'巴西',
    belarus:'白俄罗斯',
    Bermuda:'百慕大',
    Bulgaria:'保加利亚',
    NorthKorea:'北朝鲜',
    NorthernMarianaIslands:'北马里亚纳群岛',
    BacNinh:'北宁',
    Belgium:'比利时',
    Iceland:'冰岛',
    PuertoRico:'波多黎各',
    Poland:'波兰',
    BosniaAndHerzegovina:'波斯尼亚和黑塞哥维那',
    Bolivia:'玻利维亚',
    Belize:'伯利兹',
    BozWana:'博兹瓦纳',
    Bhutan:'不丹',
    BurkinaFaso:'布基纳法索',
    Burundi:'布隆迪',
    EquatorialGuinea:'赤道几内亚',
    Denmark:'丹麦',
    EastTimor:'东帝汶',
    Togo:'多哥',
    Dominica:'多米尼加',
    DominicanRepublic:'多明尼加共和国',
    Russia:'俄国',
    Ecuador:'厄瓜多尔',
    eritrea:'厄立特里亚',
    France:'法国',
    TheFaroeIslands:'法罗群岛',
    FrenchPolynesia:'法属波利尼西亚',
    Vatican:'梵蒂冈',
    ThePhilippines:'菲律宾',
    Fiji:'斐济',
    Finland:"芬兰",
    CapeVerde:'佛得角',
    Franks:'佛兰克群岛',
    Gambia:'冈比亚',
    Congo:'刚果民主共和国',
    Colombia:'哥伦比亚',
    CostaRica:'哥斯达黎加',
    grenada:'格林纳达',
    Greenland:'格陵兰',
    Georgia:'格鲁吉亚',
    Cuba:'古巴',
    Guam:'关岛',
    Guyana:'圭亚那',
    kazakhstan:'哈萨克斯坦',
    Haiti:'海地',
    Korea:'韩国',
    Netherlands:'荷兰',
    NetherlandsAntilles:'荷属安的列斯',
    Montenegro:'黑山',
    Honduras:'洪都拉斯',
    Kiribati:'基里巴斯',
    djibouti:'吉布提',
    kyrgyzstan:'吉尔吉斯斯坦',
    guinea:'几内亚',
    Canada:'加拿大',
    Ghana:'加纳',
    Gabon:'加蓬',
    Cambodia:'柬埔寨',
    CzechRepublic:'捷克共和国',
    Zimbabwe:'津巴布韦',
    Cameroon:'喀麦隆',
    Qatar:'卡塔尔',
    CaymanIslands:'开曼群岛',
    Comorin:'科摩罗',
    Kuwait:'科威特',
    Croatia:'克罗地亚',
    Kenya:'肯尼亚',
    cookIslands:'库克群岛',
    Latvia:'拉脱维亚',
    Lesotho:'莱索托',
    Laos:'老挝',
    Lithuania:'立陶宛',
    Liberia:'利比里亚',
    Libya:'利比亚',
    Liechtenstein:'列支敦士登',
    reunion:'留尼汪',
    Luxembourg:'卢森堡',
    Rwanda:'卢旺达',
    Romania:'罗马尼亚',
    Madagascar:'马达加斯加',
    Maldives:'马尔代夫',
    Malta:'马耳他',
    Malawi:'马拉维',
    Malaysia:'马来西亚',
    Macedonia:'马其顿',
    MarshallIslands:'马绍尔群岛',
    Mauritius:'毛里求斯',
    Mauritania:"毛里塔尼亚",
    AmericanSamoa:'美属萨摩亚',
    Mongolia:'蒙古',
    Montserrat:'蒙特塞拉特',
    Bangladesh:'孟加拉国',
    Peru:'秘鲁',
    Micronesia:'密克罗尼西亚',
    Burma:'缅甸',
    Moldova:'摩尔多瓦',
    Monaco:'摩纳哥',
    Mozambique:'莫桑比克',
    Mexico:'墨西哥',
    Namibia:'纳米比亚',
    SouthAfrica:'南非',
    SouthSudan:'南苏丹',
    Nauru:'瑙鲁',
    Nicaragua:'尼加拉瓜',
    Nepal:'尼泊尔',
    Niger:'尼日尔',
    Nigeria:'尼日利亚',
    niue:'纽埃',
    Norway:'挪威',
    Palau:'帕劳',
    Portugal:'葡萄牙',
    Sweden:'瑞典',
    Switzerland:'瑞士',
    Salvador:'萨尔瓦多',
    Samoa:'萨摩亚',
    Serbia:'塞尔维亚',
    SierraLeone:'塞拉利昂',
    Senegal:'塞内加尔',
    Cyprus:'塞浦路斯',
    Seychelles:'塞舌尔',
    SaudiArabia:'沙特阿拉伯',
    SaoTomeandPrincipe:'圣多美和普林西比',
    SaintHelena:'圣赫勒拿',
    SaintKittsAndNevis:'圣基茨和尼维斯',
    SaintLucia:'圣卢西亚',
    SanMarino:'圣马力诺',
    SaintPierreandMiquelon :'圣皮埃尔和密克隆',
    SriLanka:'斯里兰卡',
    Slovakia:'斯洛伐克',
    Slovenia:'斯洛文尼亚',
    Swaziland:'斯威士兰',
    Sudan:'苏丹',
    Surinam:'苏里南',
    SolomonIslands:'所罗门群岛',
    Tajikistan:'塔吉克斯坦',
    Thailand:'泰国',
    Tanzania:'坦桑尼亚',
    Tonga:'汤加',
    Tunisia:'突尼斯',
    Tuvalu:'图瓦卢',
    Turkey:'土耳其',
    Turkmenistan:'土库曼斯坦',
    Tokelau:'托克劳',
    Vanuatu:'瓦努阿图',
    Guatemala:'危地马拉',
    Venezuela:'委内瑞拉',
    Brunei:'文莱',
    Uganda:'乌干达',
    Ukraine:'乌克兰',
    Uruguay:'乌拉圭',
    Uzbekistan:'乌兹别克斯坦',
    Spain:'西班牙',
    WesternSahara:'西撒哈拉',
    Greek:'希腊',
    Singapore:'新加坡',
    NewCaledonia:'新喀里多尼亚',
    NewZealand:'新西兰',
    Hungary:'匈牙利',
    Syria:'叙利亚',
    Jamaica:'牙买加',
    Armenia:'亚美尼亚',
    Yemen:'也门',
    Iraq:'伊拉克',
    Iran:'伊朗',
    Israel:'以色列',
    Italy:'意大利',
    India:'印度',
    Indonesia:'印度尼西亚',
    England:'英国',
    BVI:'英属维尔京群岛',
    BIOT:'英属印度洋领地',
    Jordan:'约旦',
    Vietnam:'越南',
    Zambia:'赞比亚',
    Chad:'乍得',
    Gibraltar:'直布罗陀',
    Chile:'智利',
    CentralAfricanRepublic:'中非共和国'
  }

}


// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js